export default __webpack_public_path__ + "static/market-index-treemap-3009a759715973a63c6ab92c88e1f3da.png";